import { cn } from '@/lib/utils'
import { NEUTRAL_ENUM_COLOR } from '~/common/styles/enum-colors'
import { DossIcon } from '~/components/DossIcon'
import { EnumValueMark } from '~/components/shared/enum-options'

interface EnumChipProps extends EnumValueMark {
  className?: string
}

/** A single enum value as a tinted chip — used for multi-select dropdown chips and grid cells */
export const EnumChip = ({ label, color, iconName, className }: EnumChipProps) => {
  const palette = color ?? NEUTRAL_ENUM_COLOR

  return (
    <div
      className={cn(
        'inline-flex items-center rounded border py-1 text-xs',
        // A leading icon takes a tighter leading padding than text does, since the icon's own whitespace
        // supplies part of the inset
        iconName ? 'gap-1 pe-2 ps-1.5' : 'px-2',
        className,
      )}
      style={{ backgroundColor: palette.fill, borderColor: palette.border, color: palette.content }}
    >
      {iconName ? <DossIcon color={palette.content} name={iconName} size={14} /> : null}
      <span className="truncate">{label}</span>
    </div>
  )
}
